import { demo as en_demo } from "../en/demo";

/** demo — RU slice. */
export const demo: Record<keyof typeof en_demo, string> = {
  // App shell / header
  demo_app_title: "Демо мини-приложение",
  demo_status_connected: "Подключено",
  demo_status_disconnected: "Отключено",
  demo_config_version: "{name} v{version}",

  // Console
  demo_console_title: "Консоль",
  demo_console_clear: "Очистить",
  demo_console_empty: "Пока нет записей...",

  // Bridge lifecycle logs
  demo_bridge_initializing: "Инициализация моста...",
  demo_bridge_connected: "Мост подключён!",
  demo_bridge_config_loaded: "Конфигурация загружена: {name} v{version}",
  demo_bridge_config_failed: "Не удалось получить конфигурацию: {error}",
  demo_bridge_user_loaded: "Пользователь загружен: {userId}",
  demo_bridge_user_failed: "Не удалось получить пользователя: {error}",
  demo_bridge_user_updated: "Пользователь обновлён",
  demo_bridge_init_failed: "Ошибка инициализации моста: {error}",
  demo_bridge_logs_cleared: "Логи очищены",

  // User section
  demo_user_title: "Контекст пользователя",
  demo_user_result_placeholder: "Нажми кнопку, чтобы увидеть результаты...",
  demo_user_get_info: "Получить данные пользователя",
  demo_user_get_token: "Получить токен авторизации",
  demo_user_log_get_info: "Вызов user.getInfo()...",
  demo_user_log_info_retrieved: "Данные пользователя получены",
  demo_user_log_get_info_error: "Ошибка getUserInfo: {error}",
  demo_user_log_get_token: "Вызов user.getAuthToken()...",
  demo_user_log_token_retrieved: "Токен авторизации получен",
  demo_user_log_get_token_error: "Ошибка getAuthToken: {error}",

  // Modal section
  demo_modal_title: "Управление окном",
  demo_modal_default_title: "Свой заголовок",
  demo_modal_title_placeholder: "Введи заголовок...",
  demo_modal_set_title: "Задать заголовок",
  demo_modal_full_height: "Полная высота",
  demo_modal_half_height: "Половина высоты",
  demo_modal_close: "Закрыть окно",
  demo_modal_close_message: "Закрыто из демо",
  demo_modal_log_set_title: 'Задаём заголовок окна: "{title}"...',
  demo_modal_log_title_set: "Заголовок задан",
  demo_modal_log_set_title_error: "Ошибка setModalTitle: {error}",
  demo_modal_log_set_full: "Задаём высоту: полная...",
  demo_modal_log_full_set: "Высота задана: полная",
  demo_modal_log_set_half: "Задаём высоту: половина...",
  demo_modal_log_half_set: "Высота задана: половина",
  demo_modal_log_set_height_error: "Ошибка setModalHeight: {error}",
  demo_modal_log_closing: "Закрываем окно...",
  demo_modal_log_close_error: "Ошибка closeModal: {error}",

  // Toast & Alerts section
  demo_toast_title: "Тосты и оповещения",
  demo_toast_success: "Успех",
  demo_toast_error: "Ошибка",
  demo_toast_warning: "Предупреждение",
  demo_toast_info: "Инфо",
  demo_toast_alert: "Оповещение",
  demo_toast_destructive: "Опасное",
  demo_toast_message_success: "Операция выполнена успешно!",
  demo_toast_message_error: "Что-то пошло не так!",
  demo_toast_message_warning: "Будь осторожнее!",
  demo_toast_message_info: "Вот немного информации.",
  demo_toast_log_showing: "Показываем тост типа {type}...",
  demo_toast_log_shown: "Тост показан",
  demo_toast_log_show_error: "Ошибка showToast: {error}",
  demo_alert_title: "Демо-оповещение",
  demo_alert_message: "Точно хочешь продолжить это действие?",
  demo_alert_confirm: "Подтвердить",
  demo_alert_cancel: "Отмена",
  demo_alert_log_showing: "Показываем диалог оповещения...",
  demo_alert_log_result_confirmed: "Результат оповещения: Подтверждено",
  demo_alert_log_result_cancelled: "Результат оповещения: Отменено",
  demo_alert_log_error: "Ошибка showAlert: {error}",
  demo_alert_destructive_title: "Удалить элемент",
  demo_alert_destructive_message: "Это действие нельзя отменить. Ты уверен?",
  demo_alert_destructive_confirm: "Удалить",
  demo_alert_destructive_log_showing: "Показываем опасное оповещение...",
  demo_alert_destructive_log_result_deleted:
    "Результат опасного оповещения: Удалено",
  demo_alert_destructive_log_result_cancelled:
    "Результат опасного оповещения: Отменено",
  demo_alert_destructive_log_error: "Ошибка showDestructiveAlert: {error}",

  // Storage section
  demo_storage_title: "Хранилище",
  demo_storage_result_placeholder: "Результаты хранилища появятся здесь...",
  demo_storage_default_value: "Привет из мини-приложения!",
  demo_storage_key_placeholder: "Введи ключ...",
  demo_storage_value_placeholder: "Введи значение...",
  demo_storage_set: "Задать",
  demo_storage_get: "Получить",
  demo_storage_remove: "Удалить",
  demo_storage_log_setting: "Записываем в хранилище: {key} = {value}...",
  demo_storage_log_set: "Элемент записан в хранилище",
  demo_storage_log_set_error: "Ошибка setStorageItem: {error}",
  demo_storage_log_getting: "Читаем из хранилища: {key}...",
  demo_storage_log_retrieved: "Элемент хранилища получен",
  demo_storage_log_get_error: "Ошибка getStorageItem: {error}",
  demo_storage_log_removing: "Удаляем из хранилища: {key}...",
  demo_storage_log_removed: "Элемент хранилища удалён",
  demo_storage_log_remove_error: "Ошибка removeStorageItem: {error}",

  // API section
  demo_api_title: "API-прокси",
  demo_api_result_placeholder: "Результаты API появятся здесь...",
  demo_api_call: "Выполнить запрос к API",
  demo_api_log_calling: "API: {method} {endpoint}...",
  demo_api_log_success: "Запрос к API успешен ({status})",
  demo_api_log_error: "Ошибка apiCall: {error}",

  // Permissions section
  demo_permissions_title: "Разрешения",
  demo_permissions_result_placeholder:
    "Результаты разрешений появятся здесь...",
  demo_permissions_request_camera: "Запросить камеру",
  demo_permissions_request_files: "Запросить файлы",
  demo_permissions_request_location: "Запросить геолокацию",
  demo_permissions_request_notifs: "Запросить увед.",
  demo_permissions_check_camera: "Проверить камеру",
  demo_permissions_get_all: "Получить все",
  demo_permissions_log_requesting: "Запрашиваем разрешение: {permission}...",
  demo_permissions_log_granted: "Разрешение предоставлено",
  demo_permissions_log_denied: "Разрешение отклонено",
  demo_permissions_log_request_error: "Ошибка requestPermission: {error}",
  demo_permissions_log_checking: "Проверяем разрешение: {permission}...",
  demo_permissions_log_check_granted: "Разрешение {permission}: предоставлено",
  demo_permissions_log_check_not_granted:
    "Разрешение {permission}: не предоставлено",
  demo_permissions_log_check_error: "Ошибка hasPermission: {error}",
  demo_permissions_log_getting_all: "Получаем все разрешения...",
  demo_permissions_log_got_all: "Получено разрешений: {count}",
  demo_permissions_log_get_all_error: "Ошибка getPermissions: {error}",

  // Haptics section
  demo_haptics_title: "Тактильная отдача",
  demo_haptics_light: "Лёгкая",
  demo_haptics_medium: "Средняя",
  demo_haptics_heavy: "Сильная",
  demo_haptics_success: "Успех",
  demo_haptics_error: "Ошибка",
  demo_haptics_warning: "Предупреждение",
  demo_haptics_log_triggering: "Запускаем тактильную отдачу: {type}...",
  demo_haptics_log_triggered: "Тактильная отдача запущена",
  demo_haptics_log_error: "Ошибка triggerHaptic: {error}",
};
